import React from "react";
import Layout from "../components/Layout/Layout";
import NotFound from "../components/NotFound/NotFound";

const NotFoundView = () => {
  return (
    <Layout title={"VideoNalejvárny"}>
      <NotFound />
    </Layout>
  );
};

export default NotFoundView;
